const resultFunction = (availableAssets, form) => form.fromAsset || availableAssets.bitcoin || Object.values(availableAssets)[0];
const exchangeFromAssetSelectorDefinition = {
    id: 'fromAsset',
    resultFunction,
    dependencies: [{ module: 'availableAssets', selector: 'all' }, { selector: 'form' }],
};
export default exchangeFromAssetSelectorDefinition;
